import { VanillaSliderForm } from "./vanilla-slider-form";
import { VanillaSliderHandler } from "./vanilla-slider-handler";
import { VanillaSliderListener } from "./vanilla-slider-listener";

export class VanillaSliderSetup {
    private readonly root: HTMLElement;

    private readonly form: VanillaSliderForm;

    private readonly handler: VanillaSliderHandler;

    private readonly listener: VanillaSliderListener;

    public constructor(root: HTMLElement) {
        this.root = root;
        this.form = new VanillaSliderForm(root);
        this.handler = new VanillaSliderHandler(this.form);
        this.listener = new VanillaSliderListener(this.form, this.handler);
    }

    public init(): void {
        if (!(this.root instanceof HTMLElement)) return;
        if (this.form.isInitialized()) return;

        this.form.markInitialized();
        this.listener.register();
        this.handler.bootstrap();
    }

    public static init(rootEl?: ParentNode | Document | HTMLElement): void {
        const root = rootEl ?? document;
        if (!(root instanceof Document || root instanceof HTMLElement)) return;

        VanillaSliderForm.getRoots(root).forEach((el) => {
            new VanillaSliderSetup(el).init();
        });
    }
}
